<template>
    <div ref="carouselItem" class="assetResourceCarouselItem" :style="slideStyle" >
        <v-card class="assetResourceSurface" color="transparent" width="100%" height="100%" v-if="isActive">

            <v-card class="assetResourceContent" color="transparent" width="100%" height="100%" max-width="100%" max-height="100%">
                <v-img v-if="resourceIsAnImage(resource)" class="assetResourceImage" :src="resource.url + sasToken" contain></v-img>
                <template v-else-if="resourceIsAGbl(resource)">
                    <focused-item
                    :isActive="glbViewInitalized"
                    babylonPanelIdentifier="MainPanel"
                    style="height:100%; width:100%;position: absolute;"
                    :resource="resource"
                    />
                </template>
                <v-card v-else-if="resourceIsVideo(resource)" color="transparent" flat style="height:100%;width:100%;" >
                    <vue-plyr>
                        <video :src="resource.url + sasToken" :style="'max-height:' + viewHeight">
                            <source  :src="resource.url + sasToken" :type="(resource.mimeType != null) ? resource.mimeType : 'video/mp4'" size="200px">
                        </video>
                    </vue-plyr>
                </v-card>
                <div v-else-if="resourceIsImageSequence(resource) && isActive" style="width:100%;max-height:500px">
                    
                        <vue-three-sixty
                            style="height:300px;width:100%;max-height:100px"
                            :amount=resource.additionalUrls.length
                            :imagePath="Get360ProductBaseImagePath"
                            :fileName="Get360ProductImageName"
                            :containerHeight="(isFullScreen) ? '100%' : '330px'"
                            v-on:OnImageChange="OnTestMethod"
                        />
                        <v-card style="position:absolute;">
                            {{itemIndex}}
                        </v-card>
                </div>                
                <div v-else>Unsupported File Type</div> 
            </v-card>
        </v-card>


        <v-card style="position:absolute;pointer-events: none;z-index:100;bottom:50px;" width="100%" height="100%" color="transparent" flat v-if="showMetaDetails">
                <v-layout fill-height column="" justify-end="" class="pa-2">
                    
                    <v-flex shrink pointer-events: none style="pointer-events: auto;">
                        <v-textarea  v-on:change="onChangeMeta" v-model="resource.description" dark background-color="rgba(0,0,0,0.6)" style="color:red;" label="Description" filled="" auto-grow="" outlined="" hide-details="" rounded="" rows="1" dense="" placeholder="Tap here to describe resource...">
                        
                        </v-textarea>
                    </v-flex>
                    <v-flex shrink class="mt-2" style="pointer-events: auto;">
                        <v-combobox
                            v-on:change="onChangeMeta"
                            v-model="resource.tags"
                            dark
                            background-color="rgba(0,0,0,0.6)"
                            filled=""
                            chips=""
                            label="Tags"
                            multiple
                            outlined=""
                            rounded=""
                            hide-details=""
                            dense=""
                            counter=""
                            hide-no-data=""
                            deletable-chips=""
                        ></v-combobox>
                    </v-flex>
                    <v-flex shrink class="mt-2">
                        <v-card color="rgba(0,0,0,0.7" dark class="pa-2">
                            {{resource.name}}
                        </v-card>
                    </v-flex>
                    <v-flex shrink v-if="resourceIsVideo(resource)">
                        <div style="height:50px;">
                        </div>
                    </v-flex>
                </v-layout>
            </v-card>
   
    </div>
</template>

<script>
import BabylonViewer from './babylonViewer'
import FocusedItem from '@/components/Babylon/Navigators/FocusedItem.vue'
import { mapActions } from 'vuex'
import { mapState, mapGetters} from 'vuex'

export default {
    name: "AssetResourceView",
    components: {
        BabylonViewer,
        FocusedItem
    },
    props: {
        //Resource model
        resource: {
            default : null,
            type : Object
        },
        //Should meta details (such as name / tags) be shown
        showMetaDetails: {
            default : false,
            type : Boolean
        },
        //Set view height for the resource
        viewHeight: {
            default : "",
            type : String
        },
        //Is this view the currently active view (used for init checks)
        isActive : {
            default : false,
            type : Boolean
        },
        //It this resource currently fullscreen
        isFullScreen : {
            default : false,
            type : Boolean
        }
    },
    computed :{
        ...mapState("assetxpstate", [
            "asset"
        ]),

        ...mapGetters("authentication", [
            "sasToken"
        ]),
  
        Get360ProductBaseImagePath()
        {
            var upToLastDirectory = this.resource.url.substring(0,this.resource.url.lastIndexOf("/"));
            return upToLastDirectory;
        },
        Get360ProductImageName()
        {
            var extension = this.resource.name.split('.')[1];
            var name = this.resource.id + "-" + this.resource.name.substring(0,this.resource.name.lastIndexOf("_"));
            name += "_{index}." + extension;
            return name;
        },
        slideStyle()
        {
            return {
                height: "100%",
                maxHeight: "100%",
                overflow: "hidden"
            };
        }
    },
    data () {
        return {

            itemIndex :0,
            glbViewInitalized : false

        }
    },
    mounted: function () {


    },
    methods:{
        ...mapActions("assetxpstate", [
            "UpdateResourceMeta"
        ]),

        OnTestMethod(imageNumber)
        {
            this.itemIndex = imageNumber;
        },
        onChangeMeta()
        {
            this.UpdateResourceMeta({
                "assetDetailid" : this.asset.assetDetailid,
                "resourceid" : this.resource.id,
                "description" : this.resource.description,
                "tags" : this.resource.tags
            });
        },
        resourceIsAnImage(resource) {
            return resource.type == 0 || resource.type == "DefaultImage"
        },
        resourceIsAGbl(resource) {
            return resource.type == 1
        },
        resourceIsVideo(resource) {

            if(resource.mimeType != null)
            {
                return resource.mimeType.includes("video");
            }
            else
            {
                return false;
            }
        },
        resourceIsImageSequence(resource) {

            if(resource.type == 7 && resource.additionalUrls.length > 0)
            {
                return true;
            }
            else
            {
                return false;
            }

        },
        resourceIsOther(resource) {
            return resource.type == "Other"
        },
        OnInit()
        {
            this.glbViewInitalized = true;
        }
    },
    watch:{
        
        viewHeight : {
            handler(newVal)
            {

            }
        },
        isActive : {
            handler(newVal)
            {
                this.$nextTick().then(() => {

                    if (!this.$refs.carouselItem)
                    {
                        return;
                    }

                    var foundElement = this.$refs.carouselItem.querySelector(".v360-image-container");
                    if(foundElement != null)
                    {
                        var unit = this.viewHeight.substring(this.viewHeight.length -2, this.viewHeight.length);
                        var height = this.viewHeight.slice(0,-2);
                        var heightFloat = parseFloat(height);
                        heightFloat -= 50;

                        foundElement.style = "max-height:" + heightFloat + unit;
                    }

                    if(!newVal)
                    {
                        this.glbViewInitalized = false;
                    }
                });
            }
        }
         
    }
}
</script> 

<style scoped>
.assetResourceCarouselItem {
    position: relative;
    width: 100%;
    height: 100%;
    max-height: 100%;
    overflow: hidden;
}

.assetResourceSurface {
    position: relative;
    width: 100%;
    height: 100%;
    min-height: 0;
    max-height: 100%;
    overflow: hidden;
}

.assetResourceContent {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    min-height: 0;
    max-height: 100%;
    overflow: hidden;
}

.assetResourceImage {
    width: 100%;
    height: 100%;
    max-width: 100%;
    max-height: 100%;
}

:deep(.v-carousel__item),
:deep(.v-window-item),
:deep(.v-window__container) {
    overflow: hidden;
}

:deep(.v-responsive),
:deep(.v-image) {
    max-width: 100%;
    max-height: 100%;
}


.test {

}

</style>